export default {
  data() {
    return {
      filterErrors: {},
    }
  },
  created() {
    this._filterTimers = {}
  },
  methods: {
    filterState(key) {
      return this.filterErrors[key] ? false : null
    },
    filterFeedback(key) {
      return this.filterErrors[key] || ''
    },
    // used by FilterSettingEditor's @validation event — the new chip-based
    // editor can't produce malformed *,-value strings, so this just clears
    // (or, for its raw-edit escape hatch, mirrors) any error for the key.
    onFilterValidation(key, error) {
      this.$set(this.filterErrors, key, error || '')
    },
    validateFilter(key, value) {
      if (this._filterTimers[key]) clearTimeout(this._filterTimers[key])
      if (!this._filterPendingArgs) this._filterPendingArgs = {}
      this._filterPendingArgs[key] = { value }
      this._filterTimers[key] = setTimeout(() => {
        if (this._filterPendingArgs) delete this._filterPendingArgs[key]
        if (value === '' || value === null || value === undefined) {
          this.$set(this.filterErrors, key, '')
          return
        }
        const str = String(value)
        const hint = 'Format: comma-separated values. Use * for all, -value to exclude. Example: *,-Bad,Good'
        if (str.startsWith(',') || str.endsWith(',')) {
          this.$set(this.filterErrors, key, 'Remove leading or trailing commas. ' + hint)
          return
        }
        const tokens = str.split(',')
        for (const token of tokens) {
          if (token.trim() === '') {
            this.$set(this.filterErrors, key, 'Remove empty entries (double commas). ' + hint)
            return
          }
          if (token.trim() === '-') {
            this.$set(this.filterErrors, key, 'Exclusion entries need a value after the dash (e.g. -value). ' + hint)
            return
          }
        }
        this.$set(this.filterErrors, key, '')
      }, 1000)
    },
    hasFilterErrors() {
      return Object.values(this.filterErrors).some(e => !!e)
    },
    firstFilterErrorKey() {
      return Object.keys(this.filterErrors).find(k => !!this.filterErrors[k])
    },
    flushFilterValidation() {
      if (!this._filterPendingArgs) this._filterPendingArgs = {}
      Object.keys(this._filterTimers || {}).forEach(key => {
        clearTimeout(this._filterTimers[key])
        delete this._filterTimers[key]
      })
      Object.entries(this._filterPendingArgs).forEach(([key, { value }]) => {
        if (value === '' || value === null || value === undefined) {
          this.$set(this.filterErrors, key, '')
          return
        }
        const str = String(value)
        const hint = 'Format: comma-separated values. Use * for all, -value to exclude. Example: *,-Bad,Good'
        if (str.startsWith(',') || str.endsWith(',')) {
          this.$set(this.filterErrors, key, 'Remove leading or trailing commas. ' + hint)
          return
        }
        const tokens = str.split(',')
        for (const token of tokens) {
          if (token.trim() === '') { this.$set(this.filterErrors, key, 'Remove empty entries (double commas). ' + hint); return }
          if (token.trim() === '-') { this.$set(this.filterErrors, key, 'Exclusion entries need a value after the dash (e.g. -value). ' + hint); return }
        }
        this.$set(this.filterErrors, key, '')
      })
      this._filterPendingArgs = {}
    },
    scrollToFirstFilterError() {
      const key = this.firstFilterErrorKey()
      if (!key) return

      let toggleKey = null
      if (this.jsonFieldToggleMap && this.jsonFieldToggleMap[key]) {
        toggleKey = this.jsonFieldToggleMap[key]
      }
      if (!toggleKey && this.fieldPrefixSectionMap) {
        for (const [prefix, sectionKey] of this.fieldPrefixSectionMap) {
          if (key.startsWith(prefix)) { toggleKey = sectionKey; break }
        }
      }

      const sectionWasClosed = toggleKey && this.toggle && !this.toggle[toggleKey]
      if (toggleKey && this.toggle !== undefined) this.$set(this.toggle, toggleKey, true)
      const delay = sectionWasClosed ? 420 : 0

      this.$nextTick(() => setTimeout(() => {
        const row = this.$el.querySelector(`[data-field="${key}"]`)
        const scrollTarget = row || this.$el
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })
        let highlightEls
        if (row && row.tagName === 'TR') {
          const input = row.querySelector('input, select, textarea, .custom-select')
          highlightEls = input ? [input] : Array.from(row.querySelectorAll('td, th'))
        } else {
          highlightEls = [scrollTarget]
        }
        highlightEls.forEach(el => {
          el.style.transition = 'none'
          el.style.backgroundColor = '#fff3cd'
          el.style.outline = '2px solid #ffc107'
        })
        setTimeout(() => {
          highlightEls.forEach(el => {
            el.style.transition = 'background-color 1.5s ease-out, outline-color 1.5s ease-out'
            el.style.backgroundColor = ''
            el.style.outlineColor = 'transparent'
          })
          setTimeout(() => highlightEls.forEach(el => { el.style.transition = ''; el.style.outline = '' }), 1600)
        }, 800)
      }, delay))
    },
  },
  watch: {
    loading(newVal) {
      if (newVal) {
        this.filterErrors = {}
        if (this._filterTimers) {
          Object.values(this._filterTimers).forEach(t => clearTimeout(t))
          this._filterTimers = {}
        }
        this._filterPendingArgs = {}
      }
    }
  },
  beforeDestroy() {
    if (this._filterTimers) {
      Object.values(this._filterTimers).forEach(t => clearTimeout(t))
    }
  }
}
